export type ClipboardFunc = (...args: unknown[]) => unknown;

let hasClipboard = false;
const funcs: ClipboardFunc[] = [];

export function HasClipboard(): boolean {
  updateHasClipboard();
  return hasClipboard;
}

export function ListenForClipboard(func: ClipboardFunc) {
  funcs.push(func);
}

export function UnListenForClipboard(func: ClipboardFunc) {
  funcs.splice(funcs.findIndex(func));
}

export function UpdateClipboard() {
  updateHasClipboard();
  funcs.map((x) => x(hasClipboard));
}

function updateHasClipboard() {
  hasClipboard = !!localStorage.getItem('templateEditor_clipboard');
}

window.addEventListener('storage', UpdateClipboard);
